import { render } from "./settingsAside.vue?vue&type=template&id=21155917&scoped=true"
import script from "./settingsAside.vue?vue&type=script&lang=js"
export * from "./settingsAside.vue?vue&type=script&lang=js"

import "./settingsAside.vue?vue&type=style&index=0&id=21155917&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21155917"]])

export default __exports__